module.exports = __webpack_public_path__ + "media/images/flags/el-d0a42f6b9252659b162526cad0c69667.svg";